import WaitingComponent from './Waiting.vue'
let mounted = false
const Waiting = {};
// 注册Alert
Waiting.install = function (Vue) {
    const WaitingConstructor = Vue.extend(WaitingComponent)
    const instance = new WaitingConstructor();
    instance.$mount(document.createElement('div'))
    if (!mounted) {
        document.body.appendChild(instance.$el)
        mounted = true
    }
    Vue.prototype.$waiting = (text = '正在处理，请稍后...', type) => {
        if (type == 'close') {
            instance.visible = false
        } else {
            if (instance.visible) {
                return
            }
            instance.text = text
            instance.visible = true
        }
    }
    // 打开/关闭
    ['open', 'close'].forEach(function (type) {
        Vue.prototype.$waiting[type] = function (text) {
            return Vue.prototype.$waiting(text, type);
        }
    });
}

export default Waiting
